export default "__VITE_ASSET__Fw69M7HQ__"